/** Custom errors for the docs app — never throw a bare `Error`. */

/** Thrown when the HTML mount point the SPA renders into is missing. */
export class MountPointNotFoundError extends Error {
  readonly code = "MOUNT_POINT_NOT_FOUND" as const;
  constructor(selector: string) {
    super(`missing mount point: ${selector}`);
    this.name = "MountPointNotFoundError";
  }
}
